"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3630],{

/***/ 64948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Select_styles_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82836);
/* harmony import */ var _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11350);
/* harmony import */ var _Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53796);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94897);
/* harmony import */ var _layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31013);









const ReactSelect = react__WEBPACK_IMPORTED_MODULE_1__.lazy(() => Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(4800)]).then(__webpack_require__.bind(__webpack_require__, 74800)));
const ReactCreatableSelect = react__WEBPACK_IMPORTED_MODULE_1__.lazy(() => Promise.all(/* import() */[__webpack_require__.e(5502), __webpack_require__.e(6473)]).then(__webpack_require__.bind(__webpack_require__, 66473)));
const Select = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref) => {
    const { id, name, label, headingLabel, headingLabelStyleProps, errorMsg, option, required, noOptionText, noOptionHandler, labelFormatter, value = null, outline = "border", menuPlacement = "auto", menuPosition = "fixed", size = "md", components } = props, restCommonProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_7__/* .__rest */ ._)(props, ["id", "name", "label", "headingLabel", "headingLabelStyleProps", "errorMsg", "option", "required", "noOptionText", "noOptionHandler", "labelFormatter", "value", "outline", "menuPlacement", "menuPosition", "size", "components"]);
    const commonProps = Object.assign({ "aria-label": label, name, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, ref,
        value, options: option, menuPlacement,
        menuPosition, components: Object.assign({ SelectContainer: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ContainerComponent */ .e$, DropdownIndicator: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .DropdownIndicatorComponent */ .fz, Control: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ControlComponent */ .Fr, SingleValue: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .SingleValueComponent */ .G$, NoOptionsMessage: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .NoOptionsMessageComponent */ .c1, Option: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .OptionComponent */ .x8, Input: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .InputComponent */ .am, IndicatorSeparator: null, ValueContainer: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ValueComponent */ .u$, Placeholder: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .PlaceholderComponent */ .WB, ClearIndicator: _RSelectDerived_js__WEBPACK_IMPORTED_MODULE_3__/* .ClearIconComponent */ .OD }, components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : "No Option"), formatOptionLabel: labelFormatter }, restCommonProps);
    const getElementByType = () => {
        switch (props.type) {
            case "common": {
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, Object.assign({ fallback: null }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactSelect, Object.assign({}, commonProps)) })));
            }
            case "creatable": {
                const { onCreateOption, getNewOptionData, isValidNewOption, formatCreateLabel, createOptionPosition, } = props;
                const creatableProps = {
                    onCreateOption,
                    getNewOptionData,
                    isValidNewOption,
                    formatCreateLabel,
                    createOptionPosition,
                };
                return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, Object.assign({ fallback: null }, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReactCreatableSelect, Object.assign({}, commonProps, creatableProps)) })));
            }
            default: {
                return null;
            }
        }
    };
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Flex_js__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, Object.assign({ flexDirection: "column", gap: 12 }, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].GREY_900 */ .Z.GREY_900, required: required }, headingLabelStyleProps, { children: headingLabel })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_styles_js__WEBPACK_IMPORTED_MODULE_2__/* .StyledSelectWrapper */ .W, Object.assign({ outline: outline, size: size }, { children: getElementByType() })), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography_Typography_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, Object.assign({ color: _constants_colors_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"].RED */ .Z.RED, size: "s" }, { children: errorMsg }))] })));
});
Select.defaultProps = {
    type: "common",
};


//# sourceMappingURL=Select.js.map


/***/ }),

/***/ 82836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ StyledSelectWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82740);
/* harmony import */ var _constants_colors_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94897);
/* harmony import */ var _constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12308);
/* harmony import */ var _constants_theme_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63298);
/* harmony import */ var _constants_files_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65357);
/* harmony import */ var _constants_color_variant_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60603);
/* harmony import */ var _constants_zIndexList_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94069);
/* harmony import */ var _constants_ui_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10193);
/* harmony import */ var _mixins_style_mixins_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13261);
/* harmony import */ var _mixins_scrollbar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47755);
/* harmony import */ var _mixins_cursor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27106);
/* harmony import */ var _mixins_font_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79047);













const StyledSelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div */ .ZP.div `
    ${(props) => {
    const size = props === null || props === void 0 ? void 0 : props.size;
    switch (size) {
        case "sm":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    height: ${_constants_ui_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonElementSizeMap */ .K[size]};
                    &,
                    .select-value-container [data-select-value-label] {
                        ${(0,_mixins_font_js__WEBPACK_IMPORTED_MODULE_10__/* .getCommonFontStyleMixin */ .d)({ size })};
                    }
                `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                    font-size: 16px;
                    height: 48px;
                `;
    }
}};

    .select-container {
        height: 100%;
    }
    .select-control {
        font-size: 12px;
        height: 100%;
        outline: none;
        padding: 0 16px;
        box-shadow: none;

        ${({ outline }) => {
    switch (outline) {
        case "border":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: 1px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        case "underline":
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                        border: none;
                        border-radius: 0;
                        border-bottom: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_200 */ .Z.GREY_200};
                    `;
        default:
            return styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv ``;
    }
}}

        ${({ borderRadius }) => borderRadius
    ? styled_components__WEBPACK_IMPORTED_MODULE_11__/* .css */ .iv `
                      border-radius: ${borderRadius}px;
                  `
    : ""}

        &:hover {
            border-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }
    }

    .select-value-container {
        padding: 0;
        overflow: hidden;
        height: 100%;
    }

    .select-singleValue {
        margin-left: 5px;
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
    }

    .select-option {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};

        &:hover {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.selected,
        &.focused {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
        }

        &.disabled {
            color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].WHITE */ .Z.WHITE};
            background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_600 */ .Z.GREY_600};
            cursor: not-allowed;
        }
    }

    .select-input {
        input {
            caret-color: transparent;
        }
    }

    .select-control--searchable .select-input {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_1000 */ .Z.GREY_1000};
        cursor: text;

        input {
            caret-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
            color: inherit;
            cursor: text;
            font-size: 16px;
            opacity: 1 !important;
        }
    }

    .select-placeholder {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_400 */ .Z.GREY_400};
        font-family: ${_constants_fonts_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REGULAR */ .Z.REGULAR};
        font-size: 13px;
    }

    .select-dropDownIndicator {
        svg {
            width: 18px;
            height: 18px;
            transform: rotate(90deg);
        }
    }
    .select-customDropDownIndicator {
        padding: 0;
    }

    .select-noOptionMessage {
        color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].BLUE */ .Z.BLUE};
    }

    .select-multiValue {
        background-color: ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GREY_300 */ .Z.GREY_300};
        border: 2px solid ${_constants_colors_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RED */ .Z.RED};
        padding: 2px;
    }

    .select-customDropDownIndicator,
    .select-clear {
        cursor: pointer;
    }
`;


//# sourceMappingURL=Select.styles.js.map


/***/ }),

/***/ 81495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ JsonForm; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _Input_Input_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53435);
/* harmony import */ var _Select_Select_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64948);
/* harmony import */ var _TextArea_TextArea_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79057);






const JsonForm = ({ formData }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: formData.map((_schema, ix) => {
            const schema = Object.assign({ isVisible: true }, _schema);
            if (!(schema === null || schema === void 0 ? void 0 : schema.isVisible)) {
                return null;
            }
            if (schema.formInputType === "dropdown") {
                const restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._)(schema, ["formInputType"]);
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({}, restProps), ix);
            }
            else if (schema.formInputType === "input") {
                const restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._)(schema, ["formInputType"]);
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input_Input_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({}, restProps), ix);
            }
            else if (schema.formInputType === "text-area") {
                const restProps = (0,_virtual_tslib_js__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._)(schema, ["formInputType"]);
                return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextArea_TextArea_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({}, restProps), ix);
            }
        }) }));
};


//# sourceMappingURL=JsonForm.js.map


/***/ }),

/***/ 68079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var _quick_action_popup_QuickActionPopup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37372);
/* harmony import */ var _vahak_core_dist_services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96122);
/* harmony import */ var _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63118);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60054);
/* harmony import */ var _vahak_core_dist_standard_icons_warning_red_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73205);
/* harmony import */ var _vahak_core_ui_dist_components_common_JsonForm_JsonForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81495);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94204);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4628);













var DisableLoadWithRemarks = function(param) {
    var loadId = param.loadId, isOpen = param.isOpen, onToggle = param.onToggle, onRefetch = param.onRefetch;
    var ref = (0,_vahak_core_dist_services__WEBPACK_IMPORTED_MODULE_4__/* .useDeactivateLoad */ .Qg)(), deactivateLoad = ref.mutateAsync;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), csRemarksText = ref1[0], setCsRemarksText = ref1[1];
    //Events
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services__WEBPACK_IMPORTED_MODULE_4__/* .useEventTrackerService */ .fQ)().sendGAandMoEngageEvent;
    var name = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_11__/* .AppContext */ .Il).name;
    var rejectLoadCta = function() {
        return new Promise(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve) {
                return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            deactivateLoad({
                                loadId: loadId,
                                userFeedback: "".concat(csRemarksText, " (Updated by ").concat(name, ")")
                            }, {
                                onSuccess: function() {
                                    _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .A.success("Load deactivated");
                                    sendGAandMoEngageEvent({
                                        name: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_10__/* .GA4EventNamesAdminConsole.TSO_LOAD_DETAILS_SCREEN.removed_from_market */ .rWq.TSO_LOAD_DETAILS_SCREEN.removed_from_market,
                                        data: {
                                            load_id: loadId
                                        }
                                    });
                                },
                                onError: function(err) {
                                    _vahak_core_dist_components_toast_toast__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .A.error((err === null || err === void 0 ? void 0 : err.message) || "Load Not deactivated");
                                },
                                onSettled: function() {
                                    resolve(0);
                                    onToggle === null || onToggle === void 0 ? void 0 : onToggle();
                                    onRefetch === null || onRefetch === void 0 ? void 0 : onRefetch();
                                }
                            });
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(resolve) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_quick_action_popup_QuickActionPopup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isOpen: true,
            ctaText: "Deactivate Load",
            ctaAction: rejectLoadCta,
            secondaryCtaAction: onToggle,
            onToggle: onToggle,
            secondaryCtaText: "Go Back",
            titleText: "Deactivate Load",
            description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_6__/* .VerticalFlex */ .vs, {
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                margin: 20,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_IconWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        width: 120,
                        height: 120,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_dist_standard_icons_warning_red_svg__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                    }),
                    "Are you sure you want to deactivate this load ?",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_vahak_core_ui_dist_components_common_JsonForm_JsonForm__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        formData: [
                            {
                                formInputType: "text-area",
                                name: "cs-remarks",
                                onChange: function(e) {
                                    return setCsRemarksText(e.target.value);
                                },
                                width: 300,
                                required: true,
                                showCharacterCount: true,
                                helpMsg: "Min 5 char",
                                length: 200,
                                value: csRemarksText
                            }
                        ]
                    })
                ]
            }),
            commonCtaProps: {
                isRounded: true,
                disabled: csRemarksText.trim().length < 5
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisableLoadWithRemarks);


/***/ }),

/***/ 77214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ useGetLoadAllDetailsMutateV2; },
/* harmony export */   "kP": function() { return /* binding */ useGetLoadDetailsQueryV2; },
/* harmony export */   "vr": function() { return /* binding */ useGetLoadAllDetailsListV2; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50930);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41634);
/* harmony import */ var _vahak_core_dist_constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24966);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49352);
/* harmony import */ var _vahak_core_ui_dist_methods_object__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61282);











var mapParamsIntoPayload = function(params) {
    var ref, ref1;
    return {
        company_id: params === null || params === void 0 ? void 0 : params.companyId,
        created_at_string: params === null || params === void 0 ? void 0 : params.loadPostTime,
        id: params === null || params === void 0 ? void 0 : params.loadId,
        bulk_id: params === null || params === void 0 ? void 0 : params.bulkId,
        status: params === null || params === void 0 ? void 0 : (ref = params.loadStatus) === null || ref === void 0 ? void 0 : ref.map(String),
        bid_status: params === null || params === void 0 ? void 0 : (ref1 = params.bidStatus) === null || ref1 === void 0 ? void 0 : ref1.map(String),
        type: params === null || params === void 0 ? void 0 : params.vehicleType,
        preload: params === null || params === void 0 ? void 0 : params.preload,
        insurance_supported_filter: params === null || params === void 0 ? void 0 : params.insuranceSupportedFilter,
        is_insured_filter: params === null || params === void 0 ? void 0 : params.isInsuredFilter,
        city_id: params === null || params === void 0 ? void 0 : params.cityIds,
        limit: params === null || params === void 0 ? void 0 : params.limit
    };
};
function useGetLoadAllDetailsMutateV2() {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().POST;
    var getLoads = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var pageParam, payload;
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pageParam = params.pageParam;
                        payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            page_number: pageParam
                        }, (0,_vahak_core_ui_dist_methods_object__WEBPACK_IMPORTED_MODULE_8__/* .filteredObjValues */ ._n)(mapParamsIntoPayload(params)));
                        return _ctx.abrupt("return", POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALL_LOADS_V2 */ .Z.ALL_LOADS_V2, payload));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getLoads(params) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__/* .useVahakMutationQuery */ .M8)(_vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__/* .QueryNames.userLoads.adminVerifyLoad */ ._.userLoads.adminVerifyLoad, getLoads);
}
var useGetLoadAllDetailsListV2 = function(params, options) {
    var getLoadsList = function getLoadsList(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var bidStatus = params.bidStatus, bulkId = params.bulkId, companyId = params.companyId, loadId = params.loadId, loadStatus = params.loadStatus, loadPostTime = params.loadPostTime, vehicleType = params.vehicleType, preload = params.preload, insuranceSupportedFilter = params.insuranceSupportedFilter, isInsuredFilter = params.isInsuredFilter;
        var payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            page_number: pageParam,
            request_type: _vahak_core_dist_constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_REQUEST_TYPE.ELASTIC_SEARCH */ .wU.ELASTIC_SEARCH
        }, (0,_vahak_core_ui_dist_methods_object__WEBPACK_IMPORTED_MODULE_8__/* .filteredObjValues */ ._n)({
            company_id: companyId,
            created_at_string: loadPostTime,
            id: loadId,
            bulk_id: bulkId,
            status: loadStatus === null || loadStatus === void 0 ? void 0 : loadStatus.map(String),
            bid_status: bidStatus === null || bidStatus === void 0 ? void 0 : bidStatus.map(String),
            type: vehicleType,
            preload: preload,
            insurance_supported_filter: insuranceSupportedFilter,
            is_insured_filter: isInsuredFilter,
            city_id: params === null || params === void 0 ? void 0 : params.cityIds,
            limit: params === null || params === void 0 ? void 0 : params.limit
        }));
        return POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALL_LOADS_V2 */ .Z.ALL_LOADS_V2, payload);
    };
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().POST;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__/* .useVahakInfiniteQuery */ .xX)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__/* .QueryNames.getLoadAllData */ ._.getLoadAllData,
        params
    ], getLoadsList, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        getNextPageParam: function(lastPage, allPages) {
            var ref, ref1, ref2;
            if (lastPage.data && (lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.page_number) < (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.total_pages)) return (lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.page_number) + 1;
            return undefined;
        }
    }, options), {
        onSuccess: function(data) {
            var aggregatedData = [];
            data.pages.forEach(function(data) {
                var ref;
                var ref1;
                aggregatedData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(aggregatedData).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((ref1 = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.load_cards) !== null && ref1 !== void 0 ? ref1 : []));
            });
            options.onSuccess(aggregatedData);
        }
    }));
};
var useGetLoadDetailsQueryV2 = function(params, options) {
    var POST = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().POST;
    var bidStatus = params.bidStatus, bulkId = params.bulkId, companyId = params.companyId, loadId = params.loadId, loadStatus = params.loadStatus, loadPostTime = params.loadPostTime, vehicleType = params.vehicleType, preload = params.preload;
    var getLoad = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _pageParam, pageParam, payload;
            return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                            page_number: pageParam
                        }, (0,_vahak_core_ui_dist_methods_object__WEBPACK_IMPORTED_MODULE_8__/* .filteredObjValues */ ._n)({
                            company_id: companyId,
                            created_at_string: loadPostTime,
                            id: loadId ? [
                                loadId
                            ] : undefined,
                            bulk_id: bulkId,
                            status: loadStatus === null || loadStatus === void 0 ? void 0 : loadStatus.map(String),
                            bid_status: bidStatus === null || bidStatus === void 0 ? void 0 : bidStatus.map(String),
                            type: vehicleType,
                            preload: preload
                        }));
                        return _ctx.abrupt("return", POST(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALL_LOADS_V2 */ .Z.ALL_LOADS_V2, payload));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getLoad(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_4__/* .useVahakQuery */ .uE)([
        _vahak_core_dist_services_hooks_queryNames__WEBPACK_IMPORTED_MODULE_5__/* .QueryNames.getLoadAllData */ ._.getLoadAllData,
        params
    ], getLoad, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, options), {
        select: function(data) {
            var ref, ref1;
            return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.load_cards) === null || ref1 === void 0 ? void 0 : ref1[0];
        }
    }));
};


/***/ })

}]);